// libs
import { Record, List } from "immutable";


const BaseRecord = Record({
  index: -1,
  day: -1,
  week: null,
  isPast: false,
  isOverSevenDays: false,
  isToday: false,
  isHoliday: false,
  isExternalMonth: false,
  isPrevMonth: false,
  isNextMonth: false,
  eventItems: List() // List<CalendarEventItem>
});

export default class CalendarDateItem extends BaseRecord {
  init(data) {
    // console.log(data);
    return this.withMutations(s =>
      s.set("index", data.index)
       .set("day", data.day)
       .set("week", data.week)
       .set("isPast", data.isPast)
       .set("isOverSevenDays", data.isOverSevenDays)
       .set("isToday", data.isToday)
       .set("isHoliday", data.isHoliday)
       .set("isExternalMonth", data.isExternalMonth)
       .set("isPrevMonth", data.isPrevMonth)
       .set("isNextMonth", data.isNextMonth)
       .set("eventItems", data.eventItems)
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/models/CalendarDateItem.js